import React, { useEffect, useState } from 'react';
import { fetchCommunityTotal, installFlushOnHide } from '../utils/communityStats';

// A quiet line in the footer: how much has been read by everyone using the app.
// Hidden entirely when the backend is not available, rather than showing a zero
// or an error.
const CommunityCounter = () => {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchCommunityTotal().then((value) => { if (!cancelled) setTotal(value); });
    const uninstall = installFlushOnHide();
    return () => { cancelled = true; uninstall(); };
  }, []);

  if (!total || total <= 0) return null;

  return (
    <p className="text-xs mt-2 text-light-gold">
      {total.toLocaleString()} verses read by readers of this app
    </p>
  );
};

export default CommunityCounter;
